import { createContext, useContext, useState, useEffect } from 'react';

const AnimationContext = createContext();

export const useAnimationsEnabled = () => useContext(AnimationContext);

export const AnimationProvider = ({ children }) => {
    const [animationsEnabled, setAnimationsEnabled] = useState(undefined);
    const [showPerfNotice, setShowPerfNotice] = useState(false);

    useEffect(() => {
        const media = window.matchMedia('(prefers-reduced-motion: reduce)');
        if (media.matches) {
            setAnimationsEnabled(false);
        } else {
            setAnimationsEnabled(true);
        }
        const handler = () => setAnimationsEnabled(!media.matches);
        media.addEventListener('change', handler);
        return () => media.removeEventListener('change', handler);
    }, []);

    useEffect(() => {
        if (localStorage.getItem('animationsDisabledByPerf')) {
            setAnimationsEnabled(false);
            if (!sessionStorage.getItem('perfNoticeShown')) {
                setShowPerfNotice(true);
                sessionStorage.setItem('perfNoticeShown', '1');
            }
            return;
        }
        const graceUntil = localStorage.getItem('animationsPerfGraceUntil');
        if (graceUntil && Date.now() < Number(graceUntil)) {
            setAnimationsEnabled(true);
            return;
        }
        sessionStorage.setItem('perfChecked', '1');
        let frames = 0;
        let last = performance.now();
        let total = 0;
        function testRAF(now) {
            if (frames > 0) total += (now - last);
            last = now;
            frames++;
            if (frames < 11) {
                requestAnimationFrame(testRAF);
            } else {
                const avg = total / 10;
                if (avg > 80) {
                    setAnimationsEnabled(false);
                    setShowPerfNotice(true);
                    localStorage.setItem('animationsDisabledByPerf', '1');
                    sessionStorage.setItem('perfNoticeShown', '1');
                }
            }
        }
        requestAnimationFrame(testRAF);
    }, []);

    const reEnableAnimations = () => {
        localStorage.removeItem('animationsDisabledByPerf');
        localStorage.setItem('animationsPerfGraceUntil', Date.now() + 60 * 60 * 1000);
        setShowPerfNotice(false);
        window.location.reload();
    };

    const closeNotice = () => setShowPerfNotice(false);

    if (animationsEnabled === undefined) {
        return null;
    }

    return (
        <AnimationContext.Provider value={animationsEnabled}>
            {children}
            {showPerfNotice && (
                <div style={{
                    position: 'fixed', top: 20, right: 20, zIndex: 9999,
                    background: '#222', color: '#fff', padding: '1.5rem 2rem',
                    borderRadius: '1rem', boxShadow: '0 2px 12px #0008',
                    minWidth: 300, maxWidth: 400
                }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <strong>Animations Disabled</strong>
                        <button onClick={closeNotice} style={{
                            background: 'none', border: 'none', color: '#fff', fontSize: '1.2rem', cursor: 'pointer'
                        }}>×</button>
                    </div>
                    <div style={{ margin: '1rem 0' }}>
                        Animations have been disabled due to detected performance issues.
                    </div>
                    <button onClick={reEnableAnimations} style={{
                        background: 'var(--primary)', color: '#fff', border: 'none',
                        borderRadius: '0.5rem', padding: '0.5rem 1.2rem', cursor: 'pointer'
                    }}>
                        Re-enable Animations
                    </button>
                </div>
            )}
        </AnimationContext.Provider>
    );
};